module.exports = __webpack_public_path__ + "img/cv.56178a1b.svg";